import MainLayout from '../Layouts/MainLayout';
import 'bootstrap/dist/css/bootstrap.min.css';
import { motion} from 'framer-motion';
import fondo_nos from "../assets/imagenes/fondo_nosotros.jpg";
import fondo_nos2 from "../assets/imagenes/fondo_nosotros2.jpg";
import { FaRegCheckCircle } from "react-icons/fa";
import { FaStar } from "react-icons/fa";
const colors = {
  primary: '#1A6B77',
  secondary: '#FBAA2C',
  dark: '#1A1A1A',
  light: '#FFFFFF'
};

function App() {
    return (
        <MainLayout>
            <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="d-flex align-items-center position-relative"
            style={{
                backgroundImage: `url(${fondo_nos})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '100vh',
                color: '#fff'
            }}
            >
            <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}
            ></div>

            <div className="container position-relative" style={{ zIndex: 2 }}>
                <div className="row">
                <div className="col-md-6">
                    <h1 className="fw-bold display-4 mb-3">Nosotros</h1>
                    <p className="lead">  
                    Somos una solución tecnológica orientada a la eficiencia, trazabilidad y cumplimiento. Nuestro equipo integra experiencia técnica con visión institucional para responder a los más altos estándares operativos.
                    </p>
                    <a href="#detalle-servicios" className="btn btn-outline-light mt-4">
                    Ver Nosotros
                    </a>
                </div>
                </div>
            </div>
            </motion.section>
            <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="py-5 bg-light"
            >
            <div className="container">
                <div className="row align-items-center g-5">
                    <div className="col-lg-6">
                        <div className="mb-4">
                            <span
                            className="d-inline-block px-3 py-1 rounded-pill bg-opacity-10"
                            style={{
                                backgroundColor: colors.secondary,
                                color: '#FFFFFF',
                                fontSize: '0.9rem',
                                fontWeight: 600
                            }}
                            >
                            Acerca de nosotros
                            </span>
                        </div>
                        <h2
                            className="fw-bold mb-4"
                            style={{
                            color: '#1A1A1A',
                            fontSize: '2.3rem',
                            lineHeight: '1.2'
                            }}
                        >
                            Quienes Somos
                        </h2>
                        <p className="text-muted mb-4 lead">
                            En Medical Assistant, nuestra misión es promover un entorno de trabajo saludable a través de tecnología y servicios personalizados
                        </p>
                    </div>

                    <div className="col-lg-6">
                        <div className="position-relative">
                            <img
                            src={fondo_nos2}
                            alt="Equipo de Medical Assistant en acción"
                            className="img-fluid rounded-4 shadow-lg"
                            style={{
                                width: '100%',
                                maxHeight: '500px',
                                objectFit: 'cover',
                            }}
                            />
                            
                        </div>
                    </div>
                </div>
            </div>
            </motion.section>
            <motion.section
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="py-5 bg-light"
            aria-label="Planes de la Plataforma"
            >
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="mb-4">
                            <span
                                className="d-inline-block px-3 py-1 rounded-pill bg-opacity-10"
                                style={{
                                backgroundColor: colors.secondary,
                                color: '#FFFFFF',
                                fontSize: '0.9rem',
                                fontWeight: 600
                                }}
                                >
                                Planes adatables
                            </span>
                        </div>
                        <h2
                            className="fw-bold mb-4"
                            style={{
                            color: '#1A1A1A',
                            fontSize: '2.3rem',
                            lineHeight: '1.2'
                            }}
                        >
                            Escoge el plan que mejor se alinea con tu operación
                        </h2>
                        <p className="text-muted mt-3">
                        Todos los planes incluyen seguridad de datos, trazabilidad SGSI y soporte técnico especializado.
                        </p>
                    </div>

                    <div className="row row-cols-1 row-cols-md-3 g-4">
                        {[
                        {
                            name: 'Básico',
                            price: '$99/mes',
                            icon: <FaStar size={25} />,
                            bg: '#ffffff',
                            border: `1px solid ${colors.primary}`,
                            features: [
                            'Reportes de salud',
                            'Soporte multicanal (correo, chat, teléfono)',
                            'Hasta 20 usuarios',
                            ],
                        },
                        {
                            name: 'Profesional',
                            price: '$199/mes',
                            icon: <FaStar size={25} />,
                            bg: '#f0f8f9',
                            border: `2px solid ${colors.secondary}`,
                            highlight: true,
                            features: [
                            'Reportes de salud',
                            'Soporte multicanal (correo, chat, teléfono)',
                            'Hasta 100 usuarios',
                            'Acceso a Capacitaciónes',
                            ],
                        },
                        {
                            name: 'Corporativo',
                            price: '$299/mes',
                            icon: <FaStar size={25} />,
                            bg: '#ffffff',
                            border: `1px solid ${colors.primary}`,
                            features: [
                            'Reportes de salud',
                            'Soporte multicanal (correo, chat, teléfono)',
                            'Hasta 500 usuarios',
                            'Acceso a Capacitaciónes',
                            ],
                        },
                        ].map((plan, index) => (
                        <div key={index} className="col">
                            <div
                            className={`card h-100 rounded-4 p-4 shadow ${plan.highlight ? 'border border-3' : ''}`}
                            style={{
                                backgroundColor: plan.bg,
                                borderColor: plan.border,
                                transition: 'transform 0.3s ease',
                            }}
                            >
                                <h4 className="fw-semibold text-center mb-1">{plan.name}</h4>
                                <h5 className="text-center mb-3" style={{ color: colors.secondary }}>
                                    {plan.price}
                                </h5>
                                <div className="text-center mb-3" style={{ color: colors.primary }}>
                                    {plan.icon}
                                    {plan.icon}
                                    {plan.icon}
                                    {plan.icon}
                                    {plan.icon}
                                </div>
                                <ul className="list-unstyled mb-4">
                                    {plan.features.map((feature, i) => (
                                    <li key={i} className="mb-2 d-flex align-items-center">
                                        <FaRegCheckCircle className="me-2" style={{ color: colors.primary }} />
                                        {feature}
                                    </li>
                                    ))}
                                </ul>
                                <div className="text-center mt-auto">
                                    <a
                                    href="contacto"
                                    className="btn btn-outline-primary rounded-pill px-4"
                                    >
                                    Solicitar información
                                    </a>
                                </div>
                            </div>
                        </div>
                        ))}
                    </div>
                </div>
            </motion.section>
            <motion.section
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
                className="py-5 bg-white"
                aria-label="Testimonios de Clientes"
            >
                <div className="container">
                <div className="row align-items-center g-5">
                    <div className="col-md-7">
                    <div className="row row-cols-1 row-cols-md-2 g-4">
                        {[
                        {
                            name: 'Carla Fernández',
                            role: 'Gerente de Recursos Humanos',
                            company: '',
                            quote: 'La plataforma nos permitió centralizar el monitoreo de salud ocupacional con una trazabilidad impecable. El soporte es excepcional.',
                        },
                        {
                            name: 'Luis Ramírez',
                            role: 'Jefe de Seguridad y Salud',
                            company: '',
                            quote: 'Gracias a Medical Assistant, logramos reducir incidentes laborales. Los reportes son claros y accionables.',
                        },
                        {
                            name: 'María Torres',
                            role: 'Directora de Bienestar Corporativo',
                            company: '',
                            quote: 'La interfaz es intuitiva y el equipo siempre está disponible. Es una herramienta clave para nuestra estrategia de bienestar.',
                        },
                        ].map((testimonial, index) => (
                        <div key={index} className="col">
                            <div className="card h-100 border-0 shadow-sm rounded-4 p-4">
                            <p className="text-muted mb-4" style={{ fontStyle: 'italic' }}>
                                {testimonial.quote}
                            </p>
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-0" style={{ color: colors.primary }}>
                                {testimonial.name}
                                </h6>
                                <small className="text-muted">
                                {testimonial.role} – {testimonial.company}
                                </small>
                            </div>
                            </div>
                        </div>
                        ))}
                    </div>
                    </div>
                    <div className="col-md-5">
                    <div className="text-start">
                        <span
                        className="d-inline-block px-3 py-1 rounded-pill mb-3"
                        style={{
                            backgroundColor: colors.secondary,
                            color: colors.light,
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            letterSpacing: '0.5px'
                        }}
                        >
                        Opiniones reales
                        </span>
                        <h2 className="fw-bold display-5" style={{ color: '#1A1A1A' }}>
                        Lo que nuestros clientes dicen
                        </h2>
                        <p className="text-muted mt-3">
                        Empresas que confían en nuestra plataforma comparten su experiencia y resultados.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </motion.section>
        </MainLayout>
    )
}

export default App;